import axios from '../../v2/app/services/axiosService';

export default {
  getTypes() {
    return [
      {id: 'Active', name: 'Active'},
      {id: 'Unsubscribed', name: 'Unsubscribed'},
    ]
  },
  async getSubscribers(form = {}) {
    const response = await axios.get(`/api/subscribers`, {params: form});
    return response.data;
  },
  async exportSubscribers(form) { // MLD-2222
    const {data} = await axios.post(`/api/subscribers/export`, form);
    let blob = new Blob([data], {type: 'text/csv'});
    let link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = `subscribers.csv`;
    link.dispatchEvent(new MouseEvent(`click`, {bubbles: true, cancelable: true, view: window}));
    return data;
  },
  async resubscribe(form) { // MLD-2222
    const response = await axios.post(`/api/subscribers/resubscribe`, form);
    return response.data;
  },
  async unsubscribe(form) { // MLD-2222
    const response = await axios.post(`/api/subscribers/unsubscribe`, form);
    return response.data;
  },
  async create(email) { // MLD-2858
    const form = {
      email: email,
    };
    const response = await axios.post(`/api/subscribers`, form);
    return response.data;
  },
  async find(email) {
    const response = await axios.get(`/api/subscribers/find`, {params: {email: email}});
    return response.data;
  },
  async getSubscriber(subscriberID) {
    const response = await axios.get(`/api/subscribers/${subscriberID}`);
    return response.data;
  },
  async updateSubscriber(subscriberID, form) {
    const response = await axios.put(`/api/subscribers/${subscriberID}`, form);
    return response.data;
  },
  async deleteSubscriber(subscriberID) {
    const response = await axios.delete(`/api/subscribers/${subscriberID}`);
    return response.data;
  },
  async isUnsubscribed(email) { // MLD-2453
    const options = {
      params: {
        email
      }
    }
    try {
      const response = await axios.get(`/api/subscribers/check`, options);
      return response.data.is_unsubscribed;
    } catch (err) {
      return false;
    }
  }
}
